export enum ActivityStreamEntity {
    Comment = 'Comment',
    Email = 'Email',
    IroNamRequest = 'IroNamRequest',
    Approval = 'Approval',
    Attachment = 'Attachment'
}
